import script from "./TestPageStepan.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestPageStepan.vue?vue&type=script&setup=true&lang=ts"

import "./TestPageStepan.vue?vue&type=style&index=0&id=96820212&lang=css"

const __exports__ = script;

export default __exports__